import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
import { ModuleFE_Toaster, TS_ErrorBoundary, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException, sortArray, StaticLogger } from '@nu-art/ts-common';
import { MultiSelect } from '../ui-props.js';
import { TS_Icons } from '@nu-art/ts-styles';
import { ModuleFE_PermissionAccessLevel, ModuleFE_PermissionDomain, ModuleFE_PermissionGroup } from '../../_entity.js';
import { Component_BasePermissionItemEditor } from './editor-base.js';
import { Input_Text_Blur } from './components.js';
import { DropDown_PermissionProject } from '../../_entity/permission-project/ui-components.js';
import { Page_ItemsEditor } from '@nu-art/thunderstorm-frontend/components/Page_ItemsEditor/index';
import { TS_EditableItemControllerProto } from '@nu-art/thunderstorm-frontend/editable-item';
class Component_EditGroup extends Component_BasePermissionItemEditor {
    static defaultProps = {
        module: ModuleFE_PermissionGroup,
        displayResolver: (item) => ModuleFE_PermissionGroup.cache.unique(item._id)?.label ?? 'Not Found'
    };
    renderLevels = () => {
        const group = this.state.editable;
        if (!group)
            return '';
        return _jsx(TS_ErrorBoundary, { children: _jsx(TS_PropRenderer.Vertical, { label: 'Levels', children: _jsx(MultiSelect.AccessLevel, { editable: group, prop: 'accessLevelIds', className: 'domain-level-list', itemRenderer: (levelId, onDelete) => {
                        const level = ModuleFE_PermissionAccessLevel.cache.unique(levelId);
                        if (!level)
                            throw new MUSTNeverHappenException(`Could not find access level with id ${levelId}`);
                        const domain = ModuleFE_PermissionDomain.cache.unique(level.domainId);
                        if (!domain)
                            throw new MUSTNeverHappenException(`Could not find domain with id ${level.domainId}`);
                        return _jsxs(Fragment, { children: [_jsx(TS_Icons.x.component, { onClick: onDelete }), `${domain.namespace}: ${level.name} (${level.value})`] }, levelId);
                    } }) }) });
    };
    editorContent = () => {
        const group = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Input_Text_Blur, { editable: group, prop: 'label' }) }), _jsx(TS_PropRenderer.Vertical, { label: 'UI Label', children: _jsx(Input_Text_Blur, { editable: group, prop: 'uiLabel' }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Project', children: _jsx(DropDown_PermissionProject.editable, { editable: group, prop: 'projectId' }) }), this.renderLevels()] });
    };
}
class Controller_EditGroup extends TS_EditableItemControllerProto {
    static defaultProps = {
        keys: ['selected'],
        module: ModuleFE_PermissionGroup,
        editor: Component_EditGroup,
        createInitialInstance: () => ({}),
        autoSave: true
    };
}
export class PermissionGroupsEditor extends Page_ItemsEditor {
    //######################### Static #########################
    static Route = {
        key: 'group-permission-editor',
        path: 'group-permission-editor',
        Component: this
    };
    static defaultProps = {
        keys: ['selected'],
        module: ModuleFE_PermissionGroup,
        mapper: group => [group.label ?? 'Not Found'],
        sort: (items) => sortArray(items, 'label'),
        itemRenderer: group => _jsx(_Fragment, { children: group.label ?? 'Not Found' }),
        EditorRenderer: Controller_EditGroup,
        route: this.Route,
        contextMenuActions: [
            {
                label: 'Delete Group',
                action: async (item) => {
                    try {
                        await ModuleFE_PermissionGroup.v1.delete(item).executeSync();
                        return true;
                    }
                    catch (err) {
                        StaticLogger.logError({ ...err });
                        ModuleFE_Toaster.toastError(err.errorResponse.debugMessage.split('\n')[0]);
                    }
                }
            }
        ]
    };
    renderHeader() {
        return _jsx(_Fragment, { children: "Permission Group" });
    }
}
//# sourceMappingURL=permission-groups-editor.js.map